import { BUTTON, LAYOUT_COLUMNS, LAYOUT_LIST, TEXT } from '../items';
import { Translator } from '../Translator';
import { CardHelper } from './itemHelpers/CardHelper';
import { ItemOfType } from './itemHelpers/types';
import { translate } from './translate';

export const Interactive8: Translator = sequence => {
  return translate(sequence, item => {
    switch (item.__typename) {
      case 'Card':
        return {
          id: item.id,
          type: LAYOUT_LIST,
          values: {
            align: 'center'
          },
          items: [
            CardHelper(
              {
                ...item,
                title: '',
                body: ''
              } as ItemOfType<'Card'>,
              {
                width: '80vw',
                height: 'auto',
                padding: { _: '0px', md: '60px' },
                extraItems: [
                  {
                    id: `${item.id}_title`,
                    type: TEXT,
                    values: {
                      value: item.title,
                      variant: 'heading1'
                    },
                    items: []
                  },
                  {
                    type: LAYOUT_COLUMNS,
                    id: '1',
                    values: {
                      gridTemplateColumns: '1fr'
                    },
                    items: [
                      {
                        id: `${item.id}_body`,
                        type: TEXT,
                        values: {
                          value: item.body
                        },
                        items: []
                      },
                      {
                        type: BUTTON,
                        id: '1',
                        values: {
                          type: 'link',
                          title:
                            item.items &&
                            item.items.length > 0 &&
                            item.items[0].title
                              ? item.items[0].title
                              : 'More',
                          url:
                            item.items &&
                            item.items.length > 0 &&
                            item.items[0].url
                              ? item.items[0].url
                              : 'https://www.easyllama.com/',
                          showShadow: true
                        },
                        items: []
                      }
                    ]
                  }
                ]
              }
            )
          ]
        };
      default:
        return null;
    }
  });
};
